import { render, staticRenderFns } from "./market-header.vue?vue&type=template&id=93c889d6"
import script from "./market-header.vue?vue&type=script&lang=ts"
export * from "./market-header.vue?vue&type=script&lang=ts"
import style0 from "./market-header.vue?vue&type=style&index=0&id=93c889d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports